/*
* @Author: 曹俊杰
* @Date: 2024-09-22 14:27:39
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2025-05-30 14:38:06
*/ 账户中心
<template>
    <div class="accbox">
        <div class="left">
            <listMenu v-for="item in menuList" :itemData="item" :key="item.name"/>
        </div>
        <div class="right">
            <keep-alive>
                <router-view />
            </keep-alive>
        </div>
    </div>
</template>
<script>
import listMenu from '@/components/listMenu/listMenu.vue';
export default {
    components: {
        listMenu
    },
    data() {
        return {
            menuList: [
                {
                    title: '我的余额',
                    name: 'balance',
                    icon: 'el-icon-ali-qiyeyue'
                },
                {
                    title: '我的代金券',
                    name: 'voucher',
                    icon: 'el-icon-ali-wodedaijinquan',
                    authority: []
                },
                {
                    title: '推广收益',
                    name: 'promotion',
                    icon: 'el-icon-ali-tuiguangshouyi',
                    authority: []
                },
                {
                    title: '咨询VIP',
                    name: 'advisory',
                    icon: 'el-icon-ali-a-rongqi6101',
                    authority: []
                },
            ]
        };
    },
}
</script>
<style lang='scss' scoped>
.accbox {
    @include contentStyle2;
}
</style>